module.exports = __webpack_public_path__ + "img/r6.62fb47d0.jpg";